import '../dist/course-sidebar-v3.css'
import '../blueprints/course-sidebar-v3.ts'
